module.exports = __webpack_public_path__ + "static/img/testimony (25).002fa05f.jpg";